
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiTargetButton as ObcPoiTargetButtonElement} from '@oicl/openbridge-webcomponents/dist/components/poi-target-button/poi-target-button.js';
 
 
 

 
 export const ObcPoiTargetButton = createComponent({
   react: React,
   tagName: 'obc-poi-target-button',
   elementClass: ObcPoiTargetButtonElement,
   events: {
     
   }
  });
 
 